/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageMenuController = /** @class */ (function () {
            function ApPageMenuController() {
            }
            ApPageMenuController.prototype.triggerMenuEvent = function (menuItem, subAction, isOpen) {
                // Trigger menu click if needed?
            };
            return ApPageMenuController;
        }());
        Directives.ApPageMenuController = ApPageMenuController;
        angular
            .module('app.Directives')
            .controller('ApPageMenuController', ApPageMenuController);
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
